import { useBubbleBubbleCheckIn } from "@crowdcoursing/api/openapi";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { useToast } from "~hooks/useToast";

import { Route } from "../../../services/router/Route";
import { CheckInTemplate } from "../../templates/CheckIn/CheckInTemplate";

const tCheckingIn = "Checking in...";
const tCheckInSuccess = "Successfully checked in!";
const tCheckInError = "Failed to check in. Please try again.";

export const CheckInPage = () => {
  const toast = useToast();
  const { bubbleId } = useParams();
  const navigate = useNavigate();

  const { mutate } = useBubbleBubbleCheckIn({
    onError() {
      toast.error(tCheckInError);
    },
    onSuccess() {
      toast.success(tCheckInSuccess);
      navigate(Route.home());
    },
  });

  useEffect(() => {
    if (bubbleId) {
      mutate({ pathParams: { bubbleId } });
    }
  }, [bubbleId, mutate]);

  return <CheckInTemplate status={tCheckingIn} />;
};
